import { useState, useMemo, Fragment } from "react";
import _ from "lodash";

import ConditionDesignerItem from "./ConditionDesignerItem";
import useMount from '../../hooks/useMount';
import LoadingComponent from "../Commons/LoadingComponent";
import AlertModal from "../Commons/AlertModal";
import ConfirmModal from "../Commons/ConfirmModal";
import ConditionDesignerModal from "./ConditionDesignerModal";
import ConditionDesignerUserVariable from "./ConditionDesignerUserVariable";
import ConditionDesignerTableVariable from "./ConditionDesignerTableVariable";
import ConditionDesignerFormula from "./ConditionDesignerFormula";
import { dataValidator } from "../../tools/dataValidator";
import { getPathToStep } from "../../tools/GeneralHelper";

import { getLabel } from "../../tools/Dictionary";
import { MdAdd, MdContentCopy } from "react-icons/md";

import "./ConditionDesigner.css";

const ConditionDesigner = (props) =>
{

  //Props
  const IsDesktop = props.IsDesktop;
  const Access = props.Access;
  const ReadOnly = props.ReadOnly;
  const OnCloseModal = props.OnCloseModal;
  const Step = props.Step;
  const CurrentStep = props.CurrentStep;
  const ConditionProcessStep = props.ConditionProcessStep;
  const Variable = props.Variable;
  const OnConfirm = props.OnConfirm;

  //State
  const [condition, setCondition] = useState(undefined);
  const [error, setError] = useState({});
  const [loading] = useState(false);
  const [modal, setModal] = useState({
    display: false,
    groupIndex: 0,
    conditionIndex: 0,
    property: ""
  });
  const [modalUser, setModalUser] = useState({
    display: false,
    groupIndex: 0,
    conditionIndex: 0,
    property: ""
  });
  const [modalConversion, setModalConversion] = useState({
    display: false,
    groupIndex: 0,
    conditionIndex: 0,
    property: ""
  });
  const [modalFormula, setModalFormula] = useState({
    display: false,
    groupIndex: 0,
    conditionIndex: 0,
    property: ""
  });
  const [alert, setAlert] = useState({
    Title: "",
    Message: "",
    Confirm: "",
    onConfirm: () => void 0,
    Display: false
  });
  const [confirm, setConfirm] = useState({
    Title: "",
    Message: "",
    Cancel: "",
    onCancel: () => void 0,
    Confirm: "",
    onConfirm: () => void 0,
    Display: false
  });


  //Variables
  const userVariable = useMemo(() => {



    let pathStep = getPathToStep(CurrentStep, Step);

    pathStep.push(CurrentStep);
    
    
    //Step.filter(s => CurrentStep.path.some(p => p == s._id));

    let returnedComponent = [];

    pathStep.forEach((s) => {
      
      s.component.forEach(c => {

        if (c.isVariable){

          let option =  undefined;

          if (c.code == "DropDown"){
            option = c.data.option.map(o => {
              return {
                label: o.label,
                value: o.value
              }
            });
          }
          

          returnedComponent.push({
            step: s._id,
            stepTitle: s.title,
            component: c._id,
            componentName: c.name,
            componentCode: c.code,
            componentData: c.data,
            option
          });
        }

          



      });

    });

    return returnedComponent;
    
  }, [Step, CurrentStep]);


  useMount(() => {

    try{


      let currentCondition = CurrentStep.condition.find(c => c.processStep == ConditionProcessStep);


      setCondition(currentCondition);

    }catch(err){

      setAlert({
        Title: getLabel("App", "Error"),
        Message: err.message || getLabel("App", "Sorry, an unknown error has occurred. Please try again later or contact our support team for assistance."),
        Confirm: getLabel("App", "Ok"),
        onConfirm: () => setAlert(alert => ({ ...alert, Display: false })),
        Display: true
      });

    }


  }, [])

  const onClickAdd = (e, _group = undefined) => {

    setModal({
      display: true,
      groupIndex: _group  
    });

    
    
  };

  const onChooseType = (_type) => {


    if (condition.length > 10) throw new Error();


    let tempCondition = {};

    switch (_type)
    {
      case "if":
        tempCondition = {
          type: "if",
          valueLeft: {
            type: "userVariable",
            processStep: undefined,
            processStepTitle: "",
            component: undefined,
            componentName: "",
            componentCode: "",
            option: []
          },
          operator: "eq",
          valueRight: {
            type: "literal",
            data: ""
          }
        };
        break;
      case "sensor": 
        tempCondition = {
          type: "sensor",
          valueLeft: {
            type: "userVariable",
            processStep: undefined,
            processStepTitle: "",
            component: undefined,
            componentName: ""
          },
          valueRight: {
            type: "userVariable",
            processStep: undefined,
            processStepTitle: "",
            component: undefined,
            componentName: ""
          },
          sensor: {
            variable: undefined,
            variableName: "",
            tolerance: 0,
          }
        }
        break;
      default:
        throw new Error();
    }


    if (!modal.groupIndex && modal.groupIndex != 0){

      setCondition(condition => ({
        ...condition,
        data: [...condition.data, [tempCondition]]
      }));

    }else{

      let newCondition = _.cloneDeep(condition);

      try
      {

        newCondition.data[modal.groupIndex].push(tempCondition);

        setCondition(newCondition);

      } catch (err)
      {

        setAlert({
          Title: getLabel("App", "Error"),
          Message: err.message || getLabel("App", "Sorry, an unknown error has occurred. Please try again later or contact our support team for assistance."),
          Confirm: getLabel("App", "Ok"),
          onConfirm: () => setAlert(alert => ({ ...alert, Display: false })),
          Display: true
        });

        setModal({ display: false });


      }    

    }

    setModal({ display: false });
  
  };

  const onChangeType = (_data, _groupIndex, _conditionIndex, _property) =>
  {

    let newCondition = _.cloneDeep(condition);

    try
    {

      console.log("wee", _data);

      newCondition.data[_groupIndex][_conditionIndex][_property] = _data;




      setCondition(newCondition);

      onValidateField(newCondition.data)

    } catch (err)
    {

      setAlert({
        Title: getLabel("App", "Error"),
        Message: err.message || getLabel("App", "Sorry, an unknown error has occurred. Please try again later or contact our support team for assistance."),
        Confirm: getLabel("App", "Ok"),
        onConfirm: () => setAlert(alert => ({ ...alert, Display: false })),
        Display: true
      });


    }

  };

  const onChangeValue = (_data, _groupIndex, _conditionIndex, _property) => {

    let newCondition = _.cloneDeep(condition);

    try{

      newCondition.data[_groupIndex][_conditionIndex][_property].data = _data;


      setCondition(newCondition);

      onValidateField(newCondition.data)

    }catch(err){

      setAlert({
        Title: getLabel("App", "Error"),
        Message: err.message || getLabel("App", "Sorry, an unknown error has occurred. Please try again later or contact our support team for assistance."),
        Confirm: getLabel("App", "Ok"),
        onConfirm: () => setAlert(alert => ({ ...alert, Display: false })),
        Display: true
      });


    }

  };

  const onChangeOperator = (_data, _groupIndex, _conditionIndex) =>
  {

    let newCondition = _.cloneDeep(condition);

    try
    {

      newCondition.data[_groupIndex][_conditionIndex]["operator"] = _data;


      setCondition(newCondition);

      onValidateField(newCondition.data)

    } catch (err)
    {

      setAlert({
        Title: getLabel("App", "Error"),
        Message: err.message || getLabel("App", "Sorry, an unknown error has occurred. Please try again later or contact our support team for assistance."),
        Confirm: getLabel("App", "Ok"),
        onConfirm: () => setAlert(alert => ({ ...alert, Display: false })),
        Display: true
      });


    }

  };

  const onClickUserVariable = (_groupIndex, _conditionIndex, _property) => {

    setModalUser({
      display: true,
      groupIndex: _groupIndex,
      conditionIndex: _conditionIndex,
      property: _property
    })

  }


  const onChangeFormula = (_groupIndex, _conditionIndex, _property) =>
  {

    setModalFormula({
      display: true,
      groupIndex: _groupIndex,
      conditionIndex: _conditionIndex,
      property: _property
    });

  }

  const onChangeUserVariable = (_index) => {

   

    let newCondition = _.cloneDeep(condition);

    try
    {


      newCondition.data[modalUser.groupIndex][modalUser.conditionIndex][modalUser.property].processStep = userVariable[_index].step;
      newCondition.data[modalUser.groupIndex][modalUser.conditionIndex][modalUser.property].processStepTitle = userVariable[_index].stepTitle;
      newCondition.data[modalUser.groupIndex][modalUser.conditionIndex][modalUser.property].component = userVariable[_index].component;
      newCondition.data[modalUser.groupIndex][modalUser.conditionIndex][modalUser.property].componentName = userVariable[_index].componentName;
      newCondition.data[modalUser.groupIndex][modalUser.conditionIndex][modalUser.property].componentCode = userVariable[_index].componentCode;
      newCondition.data[modalUser.groupIndex][modalUser.conditionIndex][modalUser.property].componentData = userVariable[_index].componentData;
      newCondition.data[modalUser.groupIndex][modalUser.conditionIndex][modalUser.property].option = userVariable[_index].option;

      setCondition(newCondition);

      setModalUser({ display: false })


    } catch (err)
    {

      setAlert({
        Title: getLabel("App", "Error"),
        Message: err.message || getLabel("App", "Sorry, an unknown error has occurred. Please try again later or contact our support team for assistance."),
        Confirm: getLabel("App", "Ok"),
        onConfirm: () => setAlert(alert => ({ ...alert, Display: false })),
        Display: true
      });

      setModalUser({ display: false })


    }

  };

  const onChangeGlobalVariable = (e, _groupIndex, _conditionIndex, _property) => {


    let newCondition = _.cloneDeep(condition);

    try
    {

      let currentVariable = Variable.find(v => v._id == e.target.value);

      newCondition.data[_groupIndex][_conditionIndex][_property].variable = currentVariable._id;
      newCondition.data[_groupIndex][_conditionIndex][_property].variableName = currentVariable.name;



      setCondition(newCondition);

      onValidateField(newCondition.data)

    } catch (err)
    {

      setAlert({
        Title: getLabel("App", "Error"),
        Message: err.message || getLabel("App", "Sorry, an unknown error has occurred. Please try again later or contact our support team for assistance."),
        Confirm: getLabel("App", "Ok"),
        onConfirm: () => setAlert(alert => ({ ...alert, Display: false })),
        Display: true
      });

      setModalUser({ display: false })


    }


  };

  const onChangeTolerance = (e, _groupIndex, _conditionIndex) =>
  {


    let newCondition = _.cloneDeep(condition);

    try
    {


      newCondition.data[_groupIndex][_conditionIndex]["sensor"].tolerance = e.target.value;


      setCondition(newCondition);

      onValidateField(newCondition.data)
    } catch (err)
    {

      setAlert({
        Title: getLabel("App", "Error"),
        Message: err.message || getLabel("App", "Sorry, an unknown error has occurred. Please try again later or contact our support team for assistance."),
        Confirm: getLabel("App", "Ok"),
        onConfirm: () => setAlert(alert => ({ ...alert, Display: false })),
        Display: true
      });

      setModalUser({ display: false })


    }


  };

  const OnChangeSensorVariable = (e, _groupIndex, _conditionIndex) => {


    let newCondition = _.cloneDeep(condition);

    try
    {

      let currentVariable = Variable.find(v => v._id == e.target.value);

      newCondition.data[_groupIndex][_conditionIndex]["sensor"].variable = currentVariable._id;
      newCondition.data[_groupIndex][_conditionIndex]["sensor"].variableName = currentVariable.name;
      newCondition.data[_groupIndex][_conditionIndex]["sensor"].tolerance = currentVariable.data.tolerance;


      setCondition(newCondition);

      onValidateField(newCondition.data)


    } catch (err)
    {

      setAlert({
        Title: getLabel("App", "Error"),
        Message: err.message || getLabel("App", "Sorry, an unknown error has occurred. Please try again later or contact our support team for assistance."),
        Confirm: getLabel("App", "Ok"),
        onConfirm: () => setAlert(alert => ({ ...alert, Display: false })),
        Display: true
      });

      setModalUser({ display: false })


    }
 

  };

  const onClickConversion = (_groupIndex, _conditionIndex, _property, _variableName) =>
  {

    setModalConversion({
      display: true,
      groupIndex: _groupIndex,
      conditionIndex: _conditionIndex,
      property: _property,
      variableName: _variableName
    })

  }

  const onConfirmConversion = (_data) => {


    let newCondition = _.cloneDeep(condition);

    try
    {

      newCondition.data[modalConversion.groupIndex][modalConversion.conditionIndex][modalConversion.property].tableVariable = _data.variable;
      newCondition.data[modalConversion.groupIndex][modalConversion.conditionIndex][modalConversion.property].tableVariableName = _data.variableName;
      newCondition.data[modalConversion.groupIndex][modalConversion.conditionIndex][modalConversion.property].rowFind = _data.rowFind;
      newCondition.data[modalConversion.groupIndex][modalConversion.conditionIndex][modalConversion.property].rowReturn = _data.rowReturn;


      setCondition(newCondition);

      setModalConversion({ display: false })


    } catch (err)
    {

      setAlert({
        Title: getLabel("App", "Error"),
        Message: err.message || getLabel("App", "Sorry, an unknown error has occurred. Please try again later or contact our support team for assistance."),
        Confirm: getLabel("App", "Ok"),
        onConfirm: () => setAlert(alert => ({ ...alert, Display: false })),
        Display: true
      });

      setModalUser({ display: false })


    }

  };

  const OnSaveFormula = (_data, _variable) => {

    let newCondition = _.cloneDeep(condition);


    try
    {

      newCondition.data[modalFormula.groupIndex][modalFormula.conditionIndex][modalFormula.property].data = _data;
      newCondition.data[modalFormula.groupIndex][modalFormula.conditionIndex][modalFormula.property].variable = _variable;


      setCondition(newCondition);

      onValidateField(newCondition.data);

      setModalFormula(formula => ({
        ...formula,
        display: false
      }));

    } catch (err)
    {

      setAlert({
        Title: getLabel("App", "Error"),
        Message: err.message || getLabel("App", "Sorry, an unknown error has occurred. Please try again later or contact our support team for assistance."),
        Confirm: getLabel("App", "Ok"),
        onConfirm: () => setAlert(alert => ({ ...alert, Display: false })),
        Display: true
      });


    }


  }

  const onClickRemoveCondition = (_groupIndex, _conditionIndex) => {

    setConfirm(confirm => ({
      Title: getLabel("App", "Delete"),
      Message: getLabel("App", "Are you sure you want to delete this entity?"),
      Cancel: getLabel("App", "No"),
      onCancel: () => setConfirm(confirm => ({ ...confirm, Display: false })),
      Confirm: getLabel("App", "Yes"),
      onConfirm: () => onRemoveCondition(_groupIndex, _conditionIndex),
      Display: true
    }));

  }

  const onRemoveCondition = (_groupIndex, _conditionIndex) =>
  {

    try
    {

      let tempCondition = _.cloneDeep(condition);

      if (tempCondition.data[_groupIndex].length <= 1){

        tempCondition.data.splice(_groupIndex, 1);

      }else{

        tempCondition.data[_groupIndex].splice(_conditionIndex, 1);

      }

      setCondition(tempCondition);


    } catch (err)
    {

      setAlert({
        Title: getLabel("App", "Error"),
        Message: err.message || getLabel("App", "Sorry, an unknown error has occurred. Please try again later or contact our support team for assistance."),
        Confirm: getLabel("App", "Ok"),
        onConfirm: () => setAlert(alert => ({ ...alert, Display: false })),
        Display: true
      });


    }   

    setConfirm(confirm => ({...confirm, Display: false}));

  };


  const onValidateField = (_condition = undefined) => {

    let currentError = {}; // Create a copy of the error object

    let Validation = []; // Array to store validation results
    let currentValidation = [];

    let isValid = true; // Flag to track overall validity

    if (!_condition) _condition = condition.data;

    _condition.forEach((group, indexG) => {

      group.forEach((c, indexC) => {

        ["valueLeft", "valueRight"].forEach(property => {

          if (c[property]){

            //Validate Value
            switch (c[property]["type"])
            {
              case "literal":

                  // Validate
                  currentValidation = dataValidator([
                    { field: indexG + "_" + indexC + "_" + property + "_data", value: c[property]["data"], listValidation: ["max:30"] }
                  ]);

                  Validation = [...Validation, ...currentValidation];

                break;
              case "userVariable":
                // Validate
                currentValidation = dataValidator([
                  { field: indexG + "_" + indexC + "_" + property + "_variable", value: c[property]["component"], listValidation: ["required"] }
                ]);

                Validation = [...Validation, ...currentValidation];
                break;
              case "globalVariable":
                // Validate
                currentValidation = dataValidator([
                  { field: indexG + "_" + indexC + "_" + property + "_global", value: c[property]["variable"], listValidation: ["required"] }
                ]);

                Validation = [...Validation, ...currentValidation];
                break;
              default:
                break;

            }

          }


        });

        if (c.type == "if"){
          
          // Validate
          currentValidation = dataValidator([
            { field: indexG + "_" + indexC + "_operator", value: c["operator"], listValidation: ["required"] }
          ]);

          Validation = [...Validation, ...currentValidation];         

        }

        if (c.type == "sensor")
        {

          // Validate Variable
          currentValidation = dataValidator([
            { field: indexG + "_" + indexC + "_sensor", value: c["sensor"].variable, listValidation: ["required"] }
          ]);

          Validation = [...Validation, ...currentValidation];

          // Validate Tolerance
          currentValidation = dataValidator([
            { field: indexG + "_" + indexC + "_sensor_tolerance", value: c["sensor"].tolerance, listValidation: ["required", "max:3", "number", "maxValue:100", "minValue:0"] }
          ]);

          Validation = [...Validation, ...currentValidation];

        }



      });

    });

    Validation.forEach(validation =>
    {
      // Iterate over each validation result
      if (validation.valid)
      {
        currentError[validation.field] = ""; // If valid, clear the corresponding error field
      } else
      {
        currentError[validation.field] = validation.reason; // If invalid, set the error reason in the corresponding field
        isValid = false; // Set isValid to false if any validation fails
      }
    });



    setError(currentError); // Update the error state

    return isValid; // Return the overall validity flag

  };

  const onClickConfirm= () => {

    try{


      if (!onValidateField()) throw new Error(getLabel("App", "The form contains errors. Please check and fix the fields highlighted in red."));

      OnConfirm(condition);

      OnCloseModal();

    } catch (err)
    {
  

      setAlert({
        Title: getLabel("App", "Error"),
        Message: err.message || getLabel("App", "Sorry, an unknown error has occurred. Please try again later or contact our support team for assistance."),
        Confirm: getLabel("App", "Ok"),
        onConfirm: () => setAlert(alert => ({ ...alert, Display: false })),
        Display: true
      });

      setModalUser({ display: false })


    }

  };

  const throwError = (_err = undefined) => {

    setAlert({
      Title: getLabel("App", "Error"),
      Message: _err.message || getLabel("App", "Sorry, an unknown error has occurred. Please try again later or contact our support team for assistance."),
      Confirm: getLabel("App", "Ok"),
      onConfirm: () => setAlert(alert => ({ ...alert, Display: false })),
      Display: true
    });    

  };

  const onClickDuplicate = (e, _indexG) => {

    setConfirm(confirm => ({
      Title: getLabel("App", "Delete"),
      Message: getLabel("ConditionDesigner", "Are you sure you want to duplicate the..."),
      Cancel: getLabel("App", "No"),
      onCancel: () => setConfirm(confirm => ({ ...confirm, Display: false })),
      Confirm: getLabel("App", "Yes"),
      onConfirm: () => onDuplicate(_indexG),
      Display: true
    }));   

  };

  const onDuplicate = (_indexG) => {

    //Hide the confirm modal
    setConfirm(confirm => ({ ...confirm, Display: false }));

    console.log(condition.data);

    let toAddCondition = _.cloneDeep(condition.data[_indexG]);


    setCondition(condition => ({
      ...condition,
      data: [
        ...condition.data,
        [...toAddCondition]
      ]
    }));

  };


  if (!condition) return null;


  return (
    <div className="page_modal_background">
      <div className="page_modal_cont" style={{ width: "900px" }}>
        <LoadingComponent
          display={loading}
          label={getLabel("App", "Loading")}
        />
        <AlertModal
          Title={alert.Title}
          Message={alert.Message}
          Confirm={alert.Confirm}
          onConfirm={alert.onConfirm}
          Display={alert.Display}
        />
        <ConfirmModal
          Display={confirm.Display}
          Title={confirm.Title}
          Message={confirm.Message}
          Cancel={confirm.Cancel}
          onCancel={confirm.onCancel}
          Confirm={confirm.Confirm}
          onConfirm={confirm.onConfirm}
        />
        {modal.display &&
          <ConditionDesignerModal
            OnCloseModal={() => setModal({ display: false })}
            OnClickType={onChooseType}
          />
        }
        {modalUser.display && 
          <ConditionDesignerUserVariable
            UserVariable={userVariable}
            OnClickVariable={onChangeUserVariable}
            OnCloseModal={() => setModalUser({ display: false })}
          />
        }
        {modalConversion.display &&
          <ConditionDesignerTableVariable
            IsDesktop={IsDesktop}
            Access={Access}
            Variable={Variable.filter(v => v.variableTypeCode == "table")}
            VariableName={modalConversion.variableName}
            Condition={condition.data[modalConversion.groupIndex][modalConversion.conditionIndex][modalConversion.property]}
            OnCloseModal={() => setModalConversion({ display: false })}
            OnConfirm={onConfirmConversion}
          />
        }
        {modalFormula.display &&
          <ConditionDesignerFormula
            UserVariable={userVariable}
            Variable={Variable}
            IsDesktop={IsDesktop}
            ReadOnly={!Access.canWrite || ReadOnly}
            Condition={condition.data[modalFormula.groupIndex][modalFormula.conditionIndex][modalFormula.property]}
            OnSaveFormula={OnSaveFormula}
            OnCloseModal={() => setModalFormula({ display: false })}
          />
        }
        
        <div className="page_modal_header_cont" style={{ marginBottom: "10px" }}>
          {getLabel("ConditionDesigner", "Condition Designer")}
        </div>
        <div className="page_modal_body_cont">
          <div className="conditiondesginer_cond_cont">
            {condition.data.map((g, indexG) => (
              <Fragment key={indexG}>
                {indexG > 0 &&
                  <div className="conditiondesigner_cond_or">
                    {getLabel("App", "Or")}
                  </div>
                }
                <div className="conditiondesginer_cond_group" key={indexG}>
                  {g.map((c, indexC) => (
                    <Fragment key={indexG + "_" + indexC}>
                      {indexC > 0 &&
                        <div className="conditiondesigner_cond_and">
                          {getLabel("App", "And")}
                        </div>
                      }
                      <ConditionDesignerItem 
                        IsDesktop={IsDesktop}
                        Access={Access}
                        ReadOnly={ReadOnly}
                        Data={c}
                        Step={Step}
                        Variable={Variable}
                        Error={error}
                        GroupIndex={indexG}
                        ConditionIndex={indexC}
                        key={indexG + "_" + indexC}
                        OnChangeValue={onChangeValue}
                        OnClickUserVariable={onClickUserVariable}
                        OnChangeGlobalVariable={onChangeGlobalVariable}
                        OnChangeFormula={onChangeFormula}
                        OnClickConversion={onClickConversion}
                        OnClickRemoveCondition={onClickRemoveCondition}
                        OnChangeSensorVariable={OnChangeSensorVariable}
                        OnChangeTolerance={onChangeTolerance}
                        OnChangeOperator={onChangeOperator}
                        OnChangeType={onChangeType}
                        ThrowError={throwError}
                      />
                    </Fragment>
                  ))}
                  <div className="conditiondesigner_variable_cond_action">
                    {(Access.canWrite && !ReadOnly) &&
                      <div className="page_button_round" style={{ marginTop: "20px", marginRight: "20px" }} title={getLabel("ConditionDesigner", "Add condition")} onClick={(e) => onClickAdd(e, indexG)}>
                        <MdAdd />
                      </div>
                    }
                    {(Access.canWrite && !ReadOnly) &&
                      <div className="page_button_round" style={{ marginTop: "20px", marginLeft: "20px" }} title={getLabel("ConditionDesigner", "Duplicate in another group")} onClick={(e) => onClickDuplicate(e, indexG)}>
                        <MdContentCopy />
                      </div>
                    }
                  </div>
                </div>
              </Fragment>
            ))}
            {(Access.canWrite && !ReadOnly) &&
              <div className="page_button_round" style={{ marginTop: "20px", backgroundColor: "#5ba644" }} title={getLabel("ConditionDesigner", "Add condition group")} onClick={(e) => onClickAdd(e)}>
                <MdAdd />
              </div>
            }
          </div>
        </div>
        <div className="page_modal_footer_cont">
          <input
            type="button"
            className="page_button page_modal_footer_button"
            value={getLabel("App", "Close")}
            style={{ backgroundColor: "grey", maxWidth: "200px" }}
            onClick={(loading && !OnCloseModal) ? undefined : OnCloseModal}
            disabled={loading}
          />
          {(Access.canWrite && !ReadOnly) &&
            <input
              type="button"
              className="page_button page_modal_footer_button"
              value={getLabel("App", "Save")}
              style={{ maxWidth: "200px" }}
              onClick={onClickConfirm}
              disabled={loading}
            />
          }
        </div>
      </div>
    </div>
  );

};

export default ConditionDesigner